<app-background
        [showStarlinkNetwork]="true"
        [showOnlyStarlinkNetwork]="true"
        [starlinkNetworkDensityMultiplier]="2"
        [starlinkNetworkBrightnessMultiplier]="1.2"
        [starlinkNetworkColor5Percent]="10"></app-background>
<div *ngIf="(baseAdminRouteActive$ | async)" class="main fade-in">
        <div class="section-header">
                <div class="heading">
                        Admin
                </div>
                <div class="description">
                        modules for super users
                </div>
        </div>
        <div class="dashboard">
                <div *ngFor="let card of (cards$ | async)" class="module" (click)="navigateToModule(card.path)">
                        <div class="top-row">
                                <div class="image">
                                        <img [src]="card.icon" class="icon-white">
                                </div>
                                <div class="module-title">{{card.name}}</div>
                        </div>
                        <div class="description">
                                {{card.description}}
                        </div>
                </div>

        </div>
        <!-- <div class="dashboard">
            <div class="module" (click)="navigateToModule('admin/manage-users')">
                    <div class="top-row">
                            <div class="image">
                                    <img src="/assets/icons/user.svg" class="icon-white">
                            </div>
                            <div class="module-title">User Management</div>
                    </div>
                    <div class="description">
                        Create and update users and permissions
                    </div>
            </div>
    </div> -->

</div>
<router-outlet *ngIf="!(baseAdminRouteActive$ | async)"></router-outlet>
